import { createLabeledMessages } from '../../../messageUtils';
const speedMeter = {
    speedTest: 'Měření rychlosti',
    connectionProblem: 'Problém s připojením k internetu',
    repeatTest: 'Opakovat test',
    excellent: 'Vynikající',
    sufficient: 'Dostatečná',
    insufficient: 'Nedostatečná',
    connectionSpeed: 'Rychlost připojení je',
    errorDuringTest: 'Při měření se vyskytla chyba',
    download: 'Download',
    upload: 'Upload',
    ping: 'Ping',
    mbs: 'MB/s',
    ms: 'ms',
    badResponse: 'Server vrátil špatnou odpověď – chyba není na Vaší straně',
    connectionLost: 'Připojení k internetu bylo ztraceno'
};
export default Object.assign({}, speedMeter, createLabeledMessages(speedMeter));
